export class SelectListMultiSelect {
    id: String;
    itemName: String;

    constructor(id: String, itemName: String) {
        this.id = id;
        this.itemName = itemName;
    }
}
